import React, { useState } from "react";
import urls from "../../../constants";
import { CurrencyConvertion, FormatValueDecimal } from "../../../utils/Validate";

const TableRow = ({
    currencyDetail,
    productitem,
    productindex,
    variantsArray,
    productConfigVariant,
    commentOpen,
    setCommentOpen,
    onProductChange,
    onNotesChange
}) => {
    const list = variantsArray?.filter(d => d?.sid === productitem?.sid) ?? [];

    const visibleColumns = (productConfigVariant || [])
        .filter(v => !urls?.HIDDEN_FIELDS_GROUP?.includes(v?.groupId))
        .sort((a, b) => (a?.sequence ?? 0) - (b?.sequence ?? 0));

    const quantityValue = productitem?.qtyValues || "0";

    const quoteQty = Number(productitem?.qtyValues || 0);
    const releasedQty = Number(productitem?.releasedQuantity || 0);
    const balanceQty = Number(productitem?.availableForCurrentOrderQuantity ?? Math.max(quoteQty - releasedQty, 0));

    // negative margin check
    const marginValue = Number(productitem?.margin || 0);
    const isNegativeMargin = marginValue < 0;

    const [rowErrorMsg, setRowErrorMsg] = useState("");

    const handleClearError = () => {
        if (rowErrorMsg) setRowErrorMsg("");
    };

    const handleLpoQtyChange = (e) => {
        const enteredValue = e.target.value;
        const numericValue = Number(enteredValue);

        if (enteredValue === "") {
            setRowErrorMsg("");
            onProductChange(e, productitem);
            return;
        }

        if (numericValue > balanceQty) {
            setRowErrorMsg(`Quote item has only ${balanceQty} quantity available for this order.`);
            return;
        }

        setRowErrorMsg("");
        onProductChange(e, productitem);
    };

    return (
        <tr className={isNegativeMargin ? "negative-margin-row" : ""}>
            {visibleColumns.map((colVariant, varindex) => {
                const match = list.find(d => d?.variantId === colVariant?.variantId);
                return (
                    <td key={colVariant?.variantId ?? varindex}>
                        {varindex === 0 ? (
                            <div className="custom-checkbox custom-checkbox-blue d-flex justify-content-center">
                                {productindex + 1}
                            </div>
                        ) : (match?.variantValue || "")}
                    </td>
                );
            })}

            <td>
                {FormatValueDecimal(CurrencyConvertion(Number(productitem?.listPriceValues) || 0, currencyDetail?.conversionRate, currencyDetail))}
            </td>
            <td>{quantityValue}</td>
            <td>{productitem?.releasedQuantity || "0"}</td>
            <td className="lpo-qty-cell">
                <input
                    className={`form-control${rowErrorMsg ? " input-error" : ""}`}
                    name="lpoQuantity"
                    type="number"
                    min="0"
                    max={balanceQty}
                    value={productitem?.lpoQuantity}
                    onFocus={handleClearError}
                    onClick={handleClearError}
                    onChange={handleLpoQtyChange}
                />
                {rowErrorMsg && (
                    <span className="field-error-tooltip">
                        {rowErrorMsg}
                    </span>
                )}
            </td>
            <td>{marginValue.toFixed(2)}</td>
            <td>
                {FormatValueDecimal(
                    CurrencyConvertion(
                        Number(productitem?.totalPrice) || 0,
                        currencyDetail?.conversionRate,
                        currencyDetail
                    )
                )}
            </td>

            <td>
                <div className="notes-cell" title={productitem?.notes}>
                    {productitem?.notes}
                </div>
            </td>
        </tr>
    );
};

export default TableRow